module.exports = __webpack_public_path__ + "img/next.e3cf168d.svg";